import { Box } from '@zillow/constellation-10';
import { LoadingButton, LoadingHeading, LoadingParagraph, LoadingText } from '@zg-rentals/loading-components';

const FormFieldSkeleton = ({ inputWidth = '100%' }: { inputWidth?: string }) => (
  <>
    <LoadingText isLoading={true} loadingWidth="140px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
      &nbsp;
    </LoadingText>
    <LoadingText isLoading={true} loadingWidth={inputWidth} textStyle="heading-md" css={{ marginBottom: '400' }}>
      &nbsp;
    </LoadingText>
  </>
);

const HelpArticleBlockSkeleton = () => (
  <Box css={{ marginBottom: '600' }}>
    <LoadingParagraph isLoading={true} loadingWidth="85%" textStyle="body-sm" css={{ marginBottom: '200' }}>
      &nbsp;
    </LoadingParagraph>
    <LoadingParagraph isLoading={true} loadingWidth="100%" textStyle="body-sm" css={{ marginBottom: '100' }}>
      &nbsp;
    </LoadingParagraph>
    <LoadingParagraph isLoading={true} loadingWidth="92%" textStyle="body-sm">
      &nbsp;
    </LoadingParagraph>
  </Box>
);

const SubmitRequestPageSkeleton = () => (
  <Box data-testid="SubmitRequestPageSkeleton" css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)' }}>
    <Box css={{ gridColumnEnd: { base: 'span 12', xl: 'span 8' } }}>
      <FormFieldSkeleton />
      <FormFieldSkeleton />
      <Box css={{ display: 'flex', flexDirection: { base: 'column', lg: 'row' }, gap: { base: 0, lg: '400' } }}>
        <Box css={{ flex: '1 1 auto' }}>
          <LoadingText isLoading={true} loadingWidth="90px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
            &nbsp;
          </LoadingText>
          <LoadingText isLoading={true} loadingWidth="100%" textStyle="heading-md" css={{ marginBottom: '400' }}>
            &nbsp;
          </LoadingText>
        </Box>
        <Box css={{ flex: '1 1 auto' }}>
          <LoadingText isLoading={true} loadingWidth="80px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
            &nbsp;
          </LoadingText>
          <LoadingText isLoading={true} loadingWidth="100%" textStyle="heading-md" css={{ marginBottom: '400' }}>
            &nbsp;
          </LoadingText>
        </Box>
      </Box>
      <FormFieldSkeleton />
      <Box css={{ display: 'flex', flexDirection: { base: 'column', lg: 'row' }, gap: { base: 0, lg: 'sm' } }}>
        <Box css={{ flexBasis: '70%' }}>
          <LoadingText isLoading={true} loadingWidth="120px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
            &nbsp;
          </LoadingText>
          <LoadingText isLoading={true} loadingWidth="100%" textStyle="heading-md" css={{ marginBottom: '400' }}>
            &nbsp;
          </LoadingText>
        </Box>
        <Box css={{ flexBasis: '30%' }}>
          <LoadingText isLoading={true} loadingWidth="90px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
            &nbsp;
          </LoadingText>
          <LoadingText isLoading={true} loadingWidth="100%" textStyle="heading-md" css={{ marginBottom: '400' }}>
            &nbsp;
          </LoadingText>
        </Box>
      </Box>
      <LoadingText isLoading={true} loadingWidth="100px" textStyle="heading-xs" css={{ marginBottom: '100' }}>
        &nbsp;
      </LoadingText>
      <LoadingText
        isLoading={true}
        loadingWidth="100%"
        textStyle="heading-md"
        style={{ minHeight: '140px', display: 'block' }}
        css={{ marginBottom: '400' }}
      >
        &nbsp;
      </LoadingText>
      <Box css={{ display: 'flex', justifyContent: { base: 'flex-end', lg: 'flex-start' }, marginTop: '200' }}>
        <LoadingButton isLoading={true} loadingWidth="120px">
          &nbsp;
        </LoadingButton>
      </Box>
    </Box>
    <Box
      css={{
        gridColumnEnd: { base: 'span 12', xl: 'span 4' },
        marginLeft: { base: 0, xl: '1200' },
        marginTop: { base: '800', xl: 0 },
      }}
    >
      <LoadingHeading isLoading={true} loadingWidth="70%" level={6} css={{ marginBottom: '600' }}>
        &nbsp;
      </LoadingHeading>
      <HelpArticleBlockSkeleton />
      <HelpArticleBlockSkeleton />
    </Box>
  </Box>
);

export default SubmitRequestPageSkeleton;
